// database/schemas.ts
export const DB_NAME = 'MatinsAppDB';

export const schemas = {
  1: {
    metrics: 'id',
    metricLogs: 'id, metricId, timestamp, [metricId+timestamp]',
    mediaMetricLogs: 'id, metricId, timestamp',
  },
  // 2: { ... },
};
